module.exports = __webpack_public_path__ + "static/img/xsdds.b4e1d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/xsdds.png
// module id = La21
// module chunks = 1